import type { AuthError } from '@supabase/supabase-js';
import {
  classifyPublishScheduleError,
  formatIssueEnglish,
  getAuthErrorCode,
} from '@ubus/shared';
import type { TFunction } from 'i18next';
import type { MissingOrgJob, ScheduleValidationIssue } from '@ubus/shared';

export function translateAuthError(
  error: AuthError | Error,
  t: TFunction,
  mode: 'email' | 'phone' = 'email'
): string {
  const code = getAuthErrorCode(error, mode);
  if (code === 'raw') {
    return error.message?.trim() || t('errors.auth.raw');
  }
  return t(`errors.auth.${code}`);
}

export function translatePublishError(
  message: string,
  t: TFunction,
  missingHint?: MissingOrgJob[]
): string {
  const { kind, names } = classifyPublishScheduleError(message, missingHint);
  if (kind === 'raw') {
    return message.trim() || t('errors.publish.raw');
  }
  return t(`errors.publish.${kind}`, { names });
}

/** Map structured schedule validation issues to operator-facing copy. */
export function translateScheduleIssues(
  issues: ScheduleValidationIssue[],
  t: TFunction
): string {
  if (issues.length === 0) return '';
  return issues
    .map((issue) => {
      const key = `schedule.errors.${issue.code}`;
      const translated = t(key, issue.params);
      return translated === key ? formatIssueEnglish(issue) : translated;
    })
    .join('; ');
}
